/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AcquisitionClickParam } from './AcquisitionClickParam';
import {
    AcquisitionClickParamFromJSON,
    AcquisitionClickParamFromJSONTyped,
    AcquisitionClickParamToJSON,
    AcquisitionClickParamToJSONTyped,
} from './AcquisitionClickParam';

/**
 * 
 * @export
 * @interface ActivateProfileBody
 */
export interface ActivateProfileBody {
    /**
     * 
     * @type {string}
     * @memberof ActivateProfileBody
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateProfileBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateProfileBody
     */
    utmSource?: string;
    /**
     * utm_medium from the landing URL. Resolved ahead of the source for paid values, so accepting the source without it books paid spend as organic.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    utmMedium?: string;
    /**
     * utm_campaign from the landing URL, stored verbatim.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    utmCampaign?: string;
    /**
     * Path + query the signup journey started on. Joins per-page traffic to per-page signups.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    landingPage?: string;
    /**
     * 
     * @type {AcquisitionClickParam}
     * @memberof ActivateProfileBody
     */
    clickParam?: AcquisitionClickParam;
    /**
     * The ad platform's click identifier, exactly as it arrived. Stored with clickParam so an activated player can later be reported back to the platform that produced the click. Ignored unless both halves are present and the parameter is recognised.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    clickValue?: string;
    /**
     * document.referrer at landing. Separates EARNED from DIRECT for an untagged arrival.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    referrer?: string;
    /**
     * Friend invite code from ?friendInvite= URL param. Auto-accepts friendship on new account creation.
     * @type {string}
     * @memberof ActivateProfileBody
     */
    friendInviteCode?: string;
    /**
     * Unix ms. Asked once at sign-up. Required before entering an age-restricted paid competition; a neutral date rather than a yes/no age checkbox, which coaches the answer and is worth little as a record. An age under 18 is refused and no account is created.
     * @type {number}
     * @memberof ActivateProfileBody
     */
    dateOfBirth?: number;
    /**
     * The username shown on leaderboards, guilds and competitions. 3–20 characters, letters, digits, underscore, hyphen. Must be free (checked against usernames and Drop slugs).
     * @type {string}
     * @memberof ActivateProfileBody
     */
    nickname?: string;
}



/**
 * Check if a given object implements the ActivateProfileBody interface.
 */
export function instanceOfActivateProfileBody(value: object): value is ActivateProfileBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ActivateProfileBodyFromJSON(json: any): ActivateProfileBody {
    return ActivateProfileBodyFromJSONTyped(json, false);
}

export function ActivateProfileBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateProfileBody {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'email': json['email'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'utmMedium': json['utmMedium'] == null ? undefined : json['utmMedium'],
        'utmCampaign': json['utmCampaign'] == null ? undefined : json['utmCampaign'],
        'landingPage': json['landingPage'] == null ? undefined : json['landingPage'],
        'clickParam': json['clickParam'] == null ? undefined : AcquisitionClickParamFromJSON(json['clickParam']),
        'clickValue': json['clickValue'] == null ? undefined : json['clickValue'],
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
        'friendInviteCode': json['friendInviteCode'] == null ? undefined : json['friendInviteCode'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
    };
}

export function ActivateProfileBodyToJSON(json: any): ActivateProfileBody {
    return ActivateProfileBodyToJSONTyped(json, false);
}

export function ActivateProfileBodyToJSONTyped(value?: ActivateProfileBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCode': value['referralCode'],
        'email': value['email'],
        'utmSource': value['utmSource'],
        'utmMedium': value['utmMedium'],
        'utmCampaign': value['utmCampaign'],
        'landingPage': value['landingPage'],
        'clickParam': AcquisitionClickParamToJSON(value['clickParam']),
        'clickValue': value['clickValue'],
        'referrer': value['referrer'],
        'friendInviteCode': value['friendInviteCode'],
        'dateOfBirth': value['dateOfBirth'],
        'nickname': value['nickname'],
    };
}

